const Report = () =>
  import(
    /* webpackChunkName: "courier-blackList" */ '@/pages/courier/black-list/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "courier-blackList" */ '@/pages/courier/black-list/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "courier-blackList" */ '@/pages/courier/black-list/edit.vue'
  )

export default {
  path: 'blackList',
  meta: {
    label: 'blackList',
    auth: 'blackList'
  },
  component: {
    name: 'Company',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CourierBlackListReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'CourierCreateBlackList',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CourierEditBlackList',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
